import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import {
  validateVendorCondition,
  vendorFromModel,
  type VendorState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const VENDOR = (
  Details: React.ComponentType<ConditionTypeDetailsProps<VendorState>>,
): ConditionType<VendorState, ModelCondition.Vendor> => ({
  name: "Vendors",
  description(state) {
    return `Vendors: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<VendorState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model: ModelCondition.Vendor) {
    return vendorFromModel(model);
  },
  toModel(state) {
    return { type: ModelCondition.VENDOR, vendors: state };
  },
  valid(state) {
    return validateVendorCondition(state).valid;
  },
});

export { type VendorState } from "@redotech/redo-model/return-flow/condition-validate";
